export const themes = {
  green: {
    /* BeHuman brand tokens — must match styles/theme.css. These are applied
       as inline style on <div className="App">, which beats :root cascade. */
    '--td-green':          '#2FBF00',
    '--td-dark-green':     '#259900',
    '--td-accent':         '#2FBF00',
    '--td-positive-green': '#2EA854',
  },
  purple: {
    // UGO Solutions brand palette
    '--td-green':          '#6A55F7',   // UGO primary purple
    '--td-dark-green':     '#5240C4',   // deeper purple for gradients/hover
    '--td-accent':         '#8061C9',   // mid-gradient purple for header
    '--td-positive-green': '#9356A0',   // lighter purple for positive states
    '--bg-screen':         '#211D33',   // UGO dark navy background
    '--bg-card':           '#2A2547',   // card surfaces
    '--bg-light-gray':     '#1A1728',   // divider sections
    '--border-color':      '#49416D',   // muted dark purple borders
    '--text-dark':         '#FAF8F3',   // UGO light cream — primary text
    '--text-medium':       '#DCD7F9',   // light lavender — secondary text
    '--text-light':        '#9E99B4',   // muted — tertiary text
    '--btn-secondary-outline': '#B4AADF', // legible lavender stroke on dark bg
  },
};
